import React, { useState, useEffect } from 'react';
import { Upload } from './Upload';
import { UnsplashSearch } from './UnsplashSearch';
import { useFeatureFlag } from '@trello/feature-flag-client';
import { useSelectCoverQuery } from '@trello/graphql/generated';
import { Analytics } from '@trello/atlassian-analytics';

interface AddCoverProps {
  cardId: string;
  navigateToSelectCover: () => void;
}

export const AddCover: React.FunctionComponent<AddCoverProps> = ({
  cardId,
  navigateToSelectCover,
}) => {
  const colorAndFullCoversEnabled = useFeatureFlag('remarkable.rmk-239', false);

  const { data } = useSelectCoverQuery({
    variables: { cardId },
    fetchPolicy: 'cache-only',
  });

  const [isUploading, setIsUploading] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const [hasSentScreenEvent, setHasSentScreenEvent] = useState(false);

  const card = data?.card;

  useEffect(() => {
    if (card && !hasSentScreenEvent) {
      Analytics.sendScreenEvent({
        name: 'unplashCoverInlineDialog',
        containers: {
          organization: {
            id: card.board.idOrganization,
          },
          board: {
            id: card.board.id,
          },
          card: {
            id: card.id,
          },
        },
      });
      setHasSentScreenEvent(true);
    }
  }, [card, hasSentScreenEvent]);

  return (
    <>
      {!isUploading && (
        <UnsplashSearch
          cardId={cardId}
          onSetCover={navigateToSelectCover}
          onSetSearching={setIsSearching}
        />
      )}
      {!isSearching && !colorAndFullCoversEnabled && (
        <>
          <Upload
            cardId={cardId}
            onFileSelected={() => {
              setIsUploading(true);
            }}
            onFileUploaded={navigateToSelectCover}
            onUploadFailed={() => {
              setIsUploading(false);
            }}
          />
        </>
      )}
    </>
  );
};
